import { VIANUVEM_API_ENDPOINT } from "./Defaults";

export const save = data => {
    let dddNumber = null,
        number,
        cellPhoneLength = data.cellphone.length;

    if (cellPhoneLength > 9) {
        dddNumber = data.cellphone.substring(0, 2);
        number = data.cellphone.substring(cellPhoneLength - 9, cellPhoneLength);
    } else {
        number = data.cellphone;
    }

    const userData = {
        name: data.fullName,
        sex: data.sex,
        cpfNumber: data.cpf,
        password: data.password,
        phoneVO: [{
            idPhoneType: 11,
            phone: number,
            dddNumber: dddNumber
        }],
        photo: data.photo,
        birthday: data.birthday.format('DD/MM/YYYY'),
        nationality: "Brasileiro",
        token: data.token
    };

    const headers = {
        "content-type": "application/json"
    }

    return new Promise((resolve, reject) => {
        fetch(
            `${VIANUVEM_API_ENDPOINT}/public/users`,
            {
                method: 'POST',
                body: JSON.stringify(userData),
                headers
            }
        )
            .then(response => {
                // resolve(true)
                if (+response.status !== 200) {
                    reject();
                }

                resolve(response.text());
            })
            .catch(reject)
    });
};



// WEBPACK FOOTER //
// ./src/integrations/UserAPI.js